import appAxios from './axios';

export const BookingsService = {
  // Создание бронирования
  async create(bookingInput) {
    const { data } = await appAxios.post(`/app/bookings`, bookingInput);
    return data
  },

  async getById(id) {
    const { data } = await appAxios.get(`/app/bookings/${id}`);
    return data
  }
};
